var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useDisclosure } from 'shared/components';
import { useMemo } from 'react';
import { EVENT_TYPE } from 'shared/utils/mixpanel';
import { useTrackEvent } from './useTrackEvent';
export var useTrackedDisclosure = function (eventName, eventProperties, props) {
    var disclosure = useDisclosure(props);
    var trackEvent = useTrackEvent();
    var trackedDisclosure = useMemo(function () {
        var originalOnOpen = disclosure.onOpen;
        var originalOnClose = disclosure.onClose;
        return __assign(__assign({}, disclosure), { onOpen: function () {
                trackEvent(EVENT_TYPE.MODAL_OPENED, window.location.pathname, eventName, eventProperties);
                originalOnOpen();
            }, onClose: function () {
                trackEvent(EVENT_TYPE.MODAL_CLOSED, window.location.pathname, eventName);
                originalOnClose();
            } });
    }, [disclosure]);
    return trackedDisclosure;
};
